import styled from "styled-components";

export const Container = styled.div`
  .packages-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 2rem auto;
    .package {
      width: 100%;
      background: #f0f0f0;
      border-radius: 24px;
      padding: 1rem;
      margin: 1rem 0;
      &.premium {
        background: #ff6a00;
        color: #fff;
        ul li {
          color: #fff;
        }
        a {
          background: #fff;
          color: #ff6a00;
        }
      }
      ul {
        padding: 0;
        li {
          width: 100%;
          margin: 0.5rem 0;
          color: black;
          font-weight: 700;
          list-style: none;
        }
      }
      .package-price {
        width: fit-content;
        background: #c2b8b3;
        border-radius: 24px;
        padding: 0.3rem;
        p {
          color: #fff;
          margin: 0;
          font-weight: 700;
        }
      }
    }
  }
  .popup-container {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h3 {
      text-align: center;
    }
    .form-container {
      background: #fff;
      width: 50%;
      form {
        width: 90%;
        margin: 0 auto;
        .form-group {
          display: flex;
          flex-direction: column;
          input {
            padding: 1rem;
            margin: 1rem 0;
            border-radius: 14px;
            border: 1px solid #cccccc;
          }
          &.buttons {
            flex-direction: row;
          }
        }
        .personal-container {
          display: flex;
          flex-direction: column;
          width: 100%;
          .buyer-name {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
          .messagge input {
            height: 100px;
          }
        }
      }
    }
  }
  @media (min-width: 867px) {
    .packages-container {
      flex-direction: row;
      width: 100%;
      .package {
        width: 29%;
        &.premium {
          transform: scale(1.1);
        }
      }
    }
  }
`;
